export const emoji = [{
  'name': '[微笑]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_001.png'></img> ",
  'replace': '\\[微笑\\]'
},
{
  'name': '[撇嘴]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_002.png'></img> ",
  'replace': '\\[撇嘴\\]'
},
{
  'name': '[色]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_003.png'></img> ",
  'replace': '\\[色\\]'
},
{
  'name': '[发呆]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_004.png'></img> ",
  'replace': '\\[发呆\\]'
},
{
  'name': '[得意]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_005.png'></img> ",
  'replace': '\\[得意\\]'
},
{
  'name': '[流泪]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_006.png'></img> ",
  'replace': '\\[流泪\\]'
},
{
  'name': '[害羞]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_007.png'></img> ",
  'replace': '\\[害羞\\]'
},
{
  'name': '[闭嘴]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_008.png'></img> ",
  'replace': '\\[闭嘴\\]'
},
{
  'name': '[睡]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_009.png'></img> ",
  'replace': '\\[睡\\]'
},
{
  'name': '[大哭]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_010.png'></img> ",
  'replace': '\\[大哭\\]'
},
{
  'name': '[尴尬]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_011.png'></img> ",
  'replace': '\\[尴尬\\]'
},
{
  'name': '[发怒]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_012.png'></img> ",
  'replace': '\\[发怒\\]'
},
{
  'name': '[调皮]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_013.png'></img> ",
  'replace': '\\[调皮\\]'
},
{
  'name': '[呲牙]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_014.png'></img> ",
  'replace': '\\[呲牙\\]'
},
{
  'name': '[惊讶]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_015.png'></img> ",
  'replace': '\\[惊讶\\]'
},
{
  'name': '[难过]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_016.png'></img> ",
  'replace': '\\[难过\\]'
},
{
  'name': '[酷]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_017.png'></img> ",
  'replace': '\\[酷\\]'
},
{
  'name': '[冷汗]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_018.png'></img> ",
  'replace': '\\[冷汗\\]'
},
{
  'name': '[抓狂]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_019.png'></img> ",
  'replace': '\\[抓狂\\]'
},
{
  'name': '[吐]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_020.png'></img> ",
  'replace': '\\[吐\\]'
},
{
  'name': '[偷笑]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_021.png'></img> ",
  'replace': '\\[偷笑\\]'
},
{
  'name': '[愉快]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_022.png'></img> ",
  'replace': '\\[愉快\\]'
},
{
  'name': '[白眼]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_023.png'></img> ",
  'replace': '\\[白眼\\]'
},
{
  'name': '[傲慢]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_024.png'></img> ",
  'replace': '\\[傲慢\\]'
},
{
  'name': '[饥饿]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_025.png'></img> ",
  'replace': '\\[饥饿\\]'
},
{
  'name': '[困]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_026.png'></img> ",
  'replace': '\\[困\\]'
},
{
  'name': '[惊恐]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_027.png'></img> ",
  'replace': '\\[惊恐\\]'
},
{
  'name': '[流汗]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_028.png'></img> ",
  'replace': '\\[流汗\\]'
},
{
  'name': '[憨笑]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_029.png'></img> ",
  'replace': '\\[憨笑\\]'
},
{
  'name': '[悠闲]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_030.png'></img> ",
  'replace': '\\[悠闲\\]'
},
{
  'name': '[奋斗]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_031.png'></img> ",
  'replace': '\\[奋斗\\]'
},
{
  'name': '[咒骂]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_032.png'></img> ",
  'replace': '\\[咒骂\\]'
},
{
  'name': '[疑问]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_033.png'></img> ",
  'replace': '\\[疑问\\]'
},
{
  'name': '[嘘]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_034.png'></img> ",
  'replace': '\\[嘘\\]'
},
{
  'name': '[晕]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_035.png'></img> ",
  'replace': '\\[晕\\]'
},
{
  'name': '[疯了]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_036.png'></img> ",
  'replace': '\\[疯了\\]'
},
{
  'name': '[衰]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_037.png'></img> ",
  'replace': '\\[衰\\]'
},
{
  'name': '[骷髅]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_038.png'></img> ",
  'replace': '\\[骷髅\\]'
},
{
  'name': '[敲打]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_039.png'></img> ",
  'replace': '\\[敲打\\]'
},
{
  'name': '[再见]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_040.png'></img> ",
  'replace': '\\[再见\\]'
},
{
  'name': '[擦汗]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_041.png'></img> ",
  'replace': '\\[擦汗\\]'
},
{
  'name': '[抠鼻]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_042.png'></img> ",
  'replace': '\\[抠鼻\\]'
},
{
  'name': '[鼓掌]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_043.png'></img> ",
  'replace': '\\[鼓掌\\]'
},
{
  'name': '[糗大了]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_044.png'></img> ",
  'replace': '\\[糗大了\\]'
},
{
  'name': '[坏笑]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_045.png'></img> ",
  'replace': '\\[坏笑\\]'
},
{
  'name': '[左哼哼]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_046.png'></img> ",
  'replace': '\\[左哼哼\\]'
},
{
  'name': '[右哼哼]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_047.png'></img> ",
  'replace': '\\[右哼哼\\]'
},
{
  'name': '[哈欠]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_048.png'></img> ",
  'replace': '\\[哈欠\\]'
},
{
  'name': '[鄙视]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_049.png'></img> ",
  'replace': '\\[鄙视\\]'
},
{
  'name': '[委屈]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_050.png'></img> ",
  'replace': '\\[委屈\\]'
},
{
  'name': '[快哭了]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_051.png'></img> ",
  'replace': '\\[快哭了\\]'
},
{
  'name': '[阴险]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_052.png'></img> ",
  'replace': '\\[阴险\\]'
},
{
  'name': '[亲亲]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_053.png'></img> ",
  'replace': '\\[亲亲\\]'
},
{
  'name': '[吓]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_054.png'></img> ",
  'replace': '\\[吓\\]'
},
{
  'name': '[可怜]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_055.png'></img> ",
  'replace': '\\[可怜\\]'
},
{
  'name': '[菜刀]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_056.png'></img> ",
  'replace': '\\[菜刀\\]'
},
{
  'name': '[西瓜]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_057.png'></img> ",
  'replace': '\\[西瓜\\]'
},
{
  'name': '[啤酒]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_058.png'></img> ",
  'replace': '\\[啤酒\\]'
},
{
  'name': '[篮球]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_059.png'></img> ",
  'replace': '\\[篮球\\]'
},
{
  'name': '[乒乓]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_060.png'></img> ",
  'replace': '\\[乒乓\\]'
},
{
  'name': '[咖啡]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_061.png'></img> ",
  'replace': '\\[咖啡\\]'
},
{
  'name': '[饭]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_062.png'></img> ",
  'replace': '\\[饭\\]'
},
{
  'name': '[猪头]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_063.png'></img> ",
  'replace': '\\[猪头\\]'
},
{
  'name': '[玫瑰]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_064.png'></img> ",
  'replace': '\\[玫瑰\\]'
},
{
  'name': '[凋谢]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_065.png'></img> ",
  'replace': '\\[凋谢\\]'
},
{
  'name': '[嘴唇]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_066.png'></img> ",
  'replace': '\\[嘴唇\\]'
},
{
  'name': '[爱心]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_067.png'></img> ",
  'replace': '\\[爱心\\]'
},
{
  'name': '[心碎]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_068.png'></img> ",
  'replace': '\\[心碎\\]'
},
{
  'name': '[蛋糕]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_069.png'></img> ",
  'replace': '\\[蛋糕\\]'
},
{
  'name': '[闪电]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_070.png'></img> ",
  'replace': '\\[闪电\\]'
},
{
  'name': '[炸弹]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_071.png'></img> ",
  'replace': '\\[炸弹\\]'
},
{
  'name': '[刀]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_072.png'></img> ",
  'replace': '\\[刀\\]'
},
{
  'name': '[足球]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_073.png'></img> ",
  'replace': '\\[足球\\]'
},
{
  'name': '[瓢虫]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_074.png'></img> ",
  'replace': '\\[瓢虫\\]'
},
{
  'name': '[便便]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_075.png'></img> ",
  'replace': '\\[便便\\]'
},
{
  'name': '[月亮]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_076.png'></img> ",
  'replace': '\\[月亮\\]'
},
{
  'name': '[太阳]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_077.png'></img> ",
  'replace': '\\[太阳\\]'
},
{
  'name': '[礼物]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_078.png'></img> ",
  'replace': '\\[礼物\\]'
},
{
  'name': '[拥抱]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_079.png'></img> ",
  'replace': '\\[拥抱\\]'
},
{
  'name': '[强]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_080.png'></img> ",
  'replace': '\\[强\\]'
},
{
  'name': '[弱]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_081.png'></img> ",
  'replace': '\\[弱\\]'
},
{
  'name': '[握手]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_082.png'></img> ",
  'replace': '\\[握手\\]'
},
{
  'name': '[胜利]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_083.png'></img> ",
  'replace': '\\[胜利\\]'
},
{
  'name': '[抱拳]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_084.png'></img> ",
  'replace': '\\[抱拳\\]'
},
{
  'name': '[勾引]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_085.png'></img> ",
  'replace': '\\[勾引\\]'
},
{
  'name': '[拳头]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_086.png'></img> ",
  'replace': '\\[拳头\\]'
},
{
  'name': '[差劲]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_087.png'></img> ",
  'replace': '\\[差劲\\]'
},
{
  'name': '[爱你]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_088.png'></img> ",
  'replace': '\\[爱你\\]'
},
{
  'name': '[NO]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_089.png'></img> ",
  'replace': '\\[NO\\]'
},
{
  'name': '[OK]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_090.png'></img> ",
  'replace': '\\[OK\\]'
},
{
  'name': '[奸笑]',
  'replace': '\\[奸笑]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_108.png'></img"
},
{
  'name': '[嘿哈]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_109.png'></img> ",
  'replace': '\\[嘿哈\\]'
},
{
  'name': '[捂脸]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_110.png'></img> ",
  'replace': '\\[捂脸\\]'
},
{
  'name': '[机智]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_111.png'></img> ",
  'replace': '\\[机智\\]'
},
{
  'name': '[耶]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_112.png'></img> ",
  'replace': '\\[耶\\]'
},
{
  'name': '[皱眉]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/d_113.png'></img> ",
  'replace': '\\[皱眉\\]'
},
{
  'name': '[笑脸]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/dd_1.png'></img> ",
  'replace': '\\[笑脸\\]'
},
{
  'name': '[生病]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/dd_2.png'></img> ",
  'replace': '\\[生病\\]'
},
{
  'name': '[破涕为笑]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/dd_3.png'></img> ",
  'replace': '\\[破涕为笑\\]'
},
{
  'name': '[吐舌]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/dd_4.png'></img> ",
  'replace': '\\[吐舌\\]'
},
{
  'name': '[emoji晕]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/dd_5.png'></img> ",
  'replace': '\\[emoji晕\\]'
},
{
  'name': '[脸红]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/dd_6.png'></img> ",
  'replace': '\\[脸红\\]'
},
{
  'name': '[恐惧]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/dd_7.png'></img> ",
  'replace': '\\[恐惧\\]'
},
{
  'name': '[失望]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/dd_8.png'></img> ",
  'replace': '\\[失望\\]'
},
{
  'name': '[眨眼]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/dd_9.png'></img> ",
  'replace': '\\[眨眼\\]'
},
{
  'name': '[满意]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/dd_10.png'></img> ",
  'replace': '\\[满意\\]'
},
{
  'name': '[无语]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/dd_11.png'></img> ",
  'replace': '\\[无语\\]'
},
{
  'name': '[恶魔]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/dd_12.png'></img> ",
  'replace': '\\[恶魔\\]'
},
{
  'name': '[鬼魂]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/dd_13.png'></img> ",
  'replace': '\\[鬼魂\\]'
},
{
  'name': '[礼盒]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/dd_14.png'></img> ",
  'replace': '\\[礼盒\\]'
},
{
  'name': '[合十]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/dd_15.png'></img> ",
  'replace': '\\[合十\\]'
},
{
  'name': '[强壮]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/dd_16.png'></img> ",
  'replace': '\\[强壮\\]'
},
{
  'name': '[钱]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/dd_17.png'></img> ",
  'replace': '\\[钱\\]'
},
{
  'name': '[气球]',
  'emoji': "<img src='https://static.mingchu.co/webapp/emoji/dd_19.png'></img> ",
  'replace': '\\[气球]'
}]
